import PropTypes from 'prop-types';
import React from 'react';

import { BLACK } from '@wetransfer/transfer/constant/colors';

const Unlock = ({ className, color }) => (
  <svg className={className} viewBox="0 0 22 29">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0001 0.25C7.64035 0.25 4.91675 2.9736 4.91675 6.33333V8.33333C4.91675 8.74755 5.25253 9.08333 5.66675 9.08333C6.08096 9.08333 6.41675 8.74755 6.41675 8.33333V6.33333C6.41675 3.80203 8.46878 1.75 11.0001 1.75C13.5314 1.75 15.5834 3.80203 15.5834 6.33333V10.9167H4.33341C2.44644 10.9167 0.916748 12.4464 0.916748 14.3333V25C0.916748 26.887 2.44644 28.4167 4.33341 28.4167H17.6667C19.5537 28.4167 21.0834 26.887 21.0834 25V14.3333C21.0834 12.4464 19.5537 10.9167 17.6667 10.9167H17.0834V6.33333C17.0834 2.9736 14.3598 0.25 11.0001 0.25ZM2.41675 14.3333C2.41675 13.2748 3.27487 12.4167 4.33341 12.4167H17.6667C18.7253 12.4167 19.5834 13.2748 19.5834 14.3333V25C19.5834 26.0585 18.7253 26.9167 17.6667 26.9167H4.33341C3.27487 26.9167 2.41675 26.0585 2.41675 25V14.3333ZM10.9999 22.3333C12.4727 22.3333 13.6666 21.1394 13.6666 19.6667C13.6666 18.1939 12.4727 17 10.9999 17C9.52716 17 8.33325 18.1939 8.33325 19.6667C8.33325 21.1394 9.52716 22.3333 10.9999 22.3333Z"
      fill={color}
    />
  </svg>
);

Unlock.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Unlock.defaultProps = {
  color: BLACK,
};

export default Unlock;
